module.exports = __webpack_public_path__ + "static/media/63.c068bb43.svg";